import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  QualificationTrainingsStatus,
  QualificationTrainingsStatusConfig,
  qualificationTrainingsStatusMapping,
} from '@wilson/interfaces';
import { NzTagModule } from 'ng-zorro-antd/tag';

@Component({
  selector: 'wilson-qualification-training-status-tag',
  template: `
    <nz-tag
      [style.backgroundColor]="statusConfig.backgroundColor"
      [style.borderColor]="statusConfig.borderColor"
      [style.color]="'var(--dark)'"
      [class]="customClass"
    >
      {{ statusConfig.translationKey | translate }}
    </nz-tag>
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, NzTagModule],
})
export class QualificationTrainingStatusTagComponent {
  @Input() status!: QualificationTrainingsStatus;
  @Input() customClass?: string;

  protected get statusConfig(): QualificationTrainingsStatusConfig {
    return (
      qualificationTrainingsStatusMapping[this.status] || {
        translationKey: this.status,
      }
    );
  }
}
